// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__58qtq","cardTitle":"styles_cardTitle__VwUPB","cardDescription":"styles_cardDescription__q97Lc","shimmer":"styles_shimmer__kCSp9"};